import { initializeSearchForm } from './shared.js';
import { hiddenClass, invisibleClass } from '../../config.js';

const megaMenuChildrenSelector = '.js-expanded-mega-menu-children';

export const initializeMobileHeader = () => {
    const parentHeader = document.querySelector('header.js-mobile-header');
    if (!parentHeader) {
        return;
    }

    initializeSearchForm(parentHeader);
    initializeSeachToggle(parentHeader);
    initializeHamburgerMenu(parentHeader);
    initializeOpenExpandedMegaMenus(parentHeader);
};

const initializeHamburgerMenu = (parentHeader) => {
    const hamburgerMenuButtons = parentHeader.querySelectorAll('.js-hamburger-menu-button');
    const expandedMenu = parentHeader.querySelector('.js-expanded-menu');
    if (hamburgerMenuButtons.length === 0 || !expandedMenu) {
        return;
    }

    hamburgerMenuButtons.forEach(button => {
        button.addEventListener('click', () => {
            expandedMenu.classList.toggle(hiddenClass);

            if (!expandedMenu.classList.contains(hiddenClass)) {
                // reset the focus for tabbing
                expandedMenu.focus();
            }
        });
    });
}

const initializeOpenExpandedMegaMenus = (parentHeader) => {
    const backButton = parentHeader.querySelector('.back-button');
    const megaMenus = parentHeader.querySelectorAll('.js-expanded-mega-menu');
    if (!backButton || megaMenus.length === 0) {
        return;
    }

    const hideabledNavItems = parentHeader.querySelectorAll('.js-hideable-nav-item');
    const expandableChildren = parentHeader.querySelectorAll(megaMenuChildrenSelector);

    backButton.addEventListener('click', () => {
        backButton.classList.add(invisibleClass);
        hideabledNavItems.forEach(item => {
            item.classList.remove(hiddenClass);
        });
        expandableChildren.forEach(child => child.classList.add(hiddenClass));
    });

    megaMenus.forEach(megaMenu => {
        megaMenu.addEventListener('click', () => {
            backButton.classList.remove(invisibleClass);
            hideabledNavItems.forEach(item => {
                item.classList.add(hiddenClass);
            });

            const children = megaMenu.parentElement.querySelector(megaMenuChildrenSelector);
            if (children) {
                children.classList.remove(hiddenClass);
            }
        });
    });
}

const initializeSeachToggle = (parentHeader) => {
    const searchContainer = parentHeader.querySelector('.js-search');
    const searchToggleButtons = parentHeader.querySelectorAll('.js-search-toggle');
    const searchInput = parentHeader.querySelector('.js-header-search-input');
    if (!searchContainer || searchToggleButtons.length === 0) {
        return;
    }

    searchToggleButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            searchContainer.classList.toggle('open');
            if (searchContainer.classList.contains('open')) {
                searchInput.focus();
            } else {
                searchInput.blur();
            }
        });
    });
}